import {
  usePackageTypesQuery,
  PackageTypesQuery,
} from "@apollo/gen/generatedOperations";

export const usePackageTypes = (): PackageTypesQuery | undefined => {
  const { data } = usePackageTypesQuery();
  return data;
};
